/** Portfolio case studies. Shared by ProjectDetail and the build-time prerenderer. */

export interface Project {
  id: string;
  title: string;
  description: string;
  fullDescription?: string;
  category: string;
  image: string;
  technologies: string[];
  features?: string[];
  challenges?: string[];
  solutions?: string[];
  liveUrl?: string;
  githubUrl?: string;
  screenshots?: string[];
  client?: string;
  duration?: string;
  year?: string;
}

export const projects: Project[] = [
  {
    id: 'learnkogit',
    title: 'Learn Kogit',
    description: 'Educational platform providing comprehensive learning resources for students and professionals.',
    fullDescription: undefined,
    category: 'Web Development',
    image: '/kogit.png',
    technologies: ['React','Supabase','Google Analytics','GCP','Tailwind CSS','Vite'],
    features: [
      'Authentication with Supabase (email/password, Google OAuth, session management)',
      'Course Dashboard with real-time progress tracking and video player',
      'User Dashboard with personalized progress and certificates',
      'Admin Panel for content management and analytics',
      'Google Analytics integration for custom event tracking',
      'Scalable deployment on GCP with CI/CD',
    ],
    liveUrl: 'https://www.learnkogit.com/',
    screenshots: [
      '/kogit.png',
      '/kogit2.png',
      '/kogit3.png',
    ],
    client: 'Learn Kogit Inc. (USA)',
    duration: '4 months',
    year: '2025'
  },
  {
    id: 'ledgertree',
    title: 'Ledger Tree Financial Group',
    description: 'Professional website for a financial services firm with client portal integration.',
    fullDescription: 'Ledger Tree Financial Group needed a professional website that reflected their expertise and trustworthiness in the financial sector. The project involved creating a modern, responsive website with detailed service pages, team profiles, and a secure client portal for document sharing and financial updates.',
    category: 'Web Development',
    image: '/ledgertree.png',
    technologies: ['Html', 'Css', 'Tailwind', 'Responsive Design'],
    features: [
      'Custom WordPress theme development',
      'Responsive design with modern aesthetics',
      'Secure client portal with document sharing',
      'Blog with financial insights and updates',
      'Team profiles and service details',
      'Contact forms with filtering by department'
    ],
    challenges: [
      'Creating a secure client portal for sensitive financial information',
      'Balancing professional aesthetics with user-friendly navigation',
      'Ensuring compatibility with various financial data integrations'
    ],
    solutions: [
      'Implemented secure authentication and encryption for the client portal',
      'Conducted extensive user testing to refine the interface',
      'Created custom API connectors for financial data integration'
    ],
    liveUrl: 'https://ledgertreefinancialgroup.com/',
    screenshots: [
      '/ledgertree.png',
      '/ledger2.png',
    ],
    client: 'Ledger Tree Financial Group',
    duration: '1 months',
    year: '2025'
  },
];

/** Search title and description for /portfolio/:id, shared with the prerenderer. */
export const projectSeo = (project: Project) => ({
  title: `${project.title} Case Study | Omnicraft Services`,
  description: (project.fullDescription || project.description).slice(0, 158),
});
